import { Link as ReactRouterLink } from 'react-router-dom';

import { Box, Flex, HStack, Link, Text } from '@frontend/components';

import type ConfigItemListPageListItemData from './types/ConfigItemListPageListItemData.interface';

const HOVER_FOCUS_LINK_STYLES = {
  backgroundColor: 'page.plateLight',
  borderLeftWidth: 5,
};

export type ConfigItemListPageListItemProps = Omit<
  ConfigItemListPageListItemData,
  'uid'
>;

const ConfigItemListPageListItem = ({
  name,
  to,
  badges = [],
}: ConfigItemListPageListItemProps) => (
  <Box
    as="li"
    borderBottomWidth={1}
    borderBottomColor="separator.divider"
    borderBottomStyle="solid"
    _last={{ border: 0 }}
  >
    <Link
      as={ReactRouterLink}
      to={to}
      display="flex"
      py={1}
      px={2}
      backgroundColor="page.surface"
      transitionDuration="normal"
      transitionProperty="all"
      borderLeftWidth={0}
      borderLeftStyle="solid"
      borderLeftColor="brand.secondary"
      _hover={HOVER_FOCUS_LINK_STYLES}
      _focus={HOVER_FOCUS_LINK_STYLES}
    >
      <Flex alignItems="center" justifyContent="space-between" w="100%">
        <Text as="span">{name}</Text>
        {badges ? (
          <HStack justifyContent="center" alignItems="center">
            {badges}
          </HStack>
        ) : null}
      </Flex>
    </Link>
  </Box>
);

export default ConfigItemListPageListItem;
